import { ActiveServices } from './ActiveServices';
import { HomeIntro } from './HomeIntro';
import { UpcomingFilings } from './UpcomingFilings';

export const HomeContent = () => {
  return (
    <div className="mx-auto flex w-full max-w-[720px] flex-col gap-5xl p-4xl">
      <HomeIntro />
      <ActiveServices />
      <UpcomingFilings />
    </div>
  );
};
